import type { LogEntry } from '../core/log/client';
import { parseCertificate, parseTbs, type ParsedCert } from '../core/x509/parse';

export interface EntrySummary {
  name: string;
  issuer: string;
  notAfter?: Date;
  notBefore?: Date;
  parsed?: ParsedCert;
  error?: string;
}

const cnOf = (dn: string): string => /(?:^|, )CN=((?:"[^"]*"|[^,])+)/.exec(dn)?.[1]?.replace(/^"|"$/g, '') ?? dn;

/** Parses the entry's certificate (or precert TBS) for table rows; never throws. */
export function summarizeEntry(e: LogEntry): EntrySummary {
  try {
    const parsed = e.entryType === 'x509' ? parseCertificate(e.cert) : parseTbs(e.cert);
    return { name: parsed.commonName, issuer: cnOf(parsed.issuer), notAfter: parsed.notAfter, notBefore: parsed.notBefore, parsed };
  } catch (err) {
    return { name: '(unparseable certificate)', issuer: '', error: err instanceof Error ? err.message : String(err) };
  }
}

export { cnOf };
